var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"day":_vm.day}},[_c('div',{staticClass:"body"},[_vm._v(" "+_vm._s(_vm.isOutOfRange ? 'Out Of Range' : 'No Data')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }